import React from "react";

const SvgLandmarkLogomarkColor = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg data-name="Layer 1" viewBox="0 0 86.82 86.82" {...props}>
      <path d="M86.81 43.41A43.41 43.41 0 1143.41 0a43.41 43.41 0 0143.4 43.41z" fill="#103f5c" />
      <path
        d="M81.09 32.06L61.78 9.54l-19.9 21.9L62.54 56.9h17.58a34.86 34.86 0 002.58-11.48 42.07 42.07 0 00-1.61-13.36z"
        fill="#fff"
      />
      <path
        d="M36.21 31.82l24.05 29.53h17.89S67.86 82.93 43.7 82.93 8.19 61.67 8.19 61.67l3-3V38.24h15v4z"
        fill="#95cfd8"
      />
    </svg>
  );
};

export default SvgLandmarkLogomarkColor;
